<template>
    <el-row class="online_wrap online_wrap_info">
        <base-title :title="title_info"></base-title>
        <el-form
            :inline="true"
            :model="task"
            label-width="100px"
            class="demo-form-inline online_wrap_info_line">
            <el-form-item label="经销商简称:" :title="task.dealer_name">{{task.dealer_short_name}}</el-form-item>
            <el-form-item label="区域:" :title="task.dealer_region">{{task.dealer_region}}</el-form-item>
            <el-form-item label="品牌:" :title="task.car_brand">{{task.car_brand}}</el-form-item>
        </el-form>
        <el-form
            :inline="true"
            :model="task"
            label-width="100px"
            class="demo-form-inline online_wrap_info_line">
            <el-form-item label="省份:" :title="task.dealer_province">{{task.dealer_province}}</el-form-item>
            <el-form-item label="城市:">{{task.dealer_city}}</el-form-item>
            <el-form-item label="执行日期:">{{task.exec_date}}</el-form-item>
            <el-form-item label="评估员:">{{task.user_num}}</el-form-item>
        </el-form>
        <el-form
            :inline="true"
            :model="task"
            label-width="100px"
            class="demo-form-inline online_wrap_info_status">
            <el-form-item label="原始分数:">{{task.original_score}}</el-form-item>
        </el-form>
        <el-form
            :inline="true"
            :model="task"
            label-width="100px"
            class="demo-form-inline online_wrap_info_status">
            <el-form-item label="当前状态:">{{task.task_status_str}}</el-form-item>
            <el-form-item label="审核人:">{{task.auditor}}</el-form-item>
        </el-form>
        <el-form
            :inline="true"
            :model="task"
            label-width="100px"
            v-for="(item,index) in auditor"
            :key="index"
            class="demo-form-inline online_wrap_info_status">
            <el-form-item :label="index===0? `一审:`:`二审:`">{{item.nickname}}</el-form-item>
            <el-form-item :label="index===0? `一审分数:`:`二审分数:`">{{item.score}}</el-form-item>
            <el-form-item :label="index===0? `一审日期:`:`二审日期:`">{{item.audit_date}}</el-form-item>
            <el-form-item :label="index===0? `一审用时:`:`二审用时:`">{{item.duration_minute}}</el-form-item>
        </el-form>
    </el-row>
</template>

<script>
export default {
  name: 'baseInfo',
  components: {
  },
  props: {
    task: {
      default: {
        dealer_short_name: '',
        code: '',
        dealer_region: '',
        car_brand: '',
        dealer_province: '',
        dealer_city: '',
        exec_date: '',
        user_num: '',
        task_status_str: '',
        auditor: '',
        original_score: ''
      },
      type: Object
    },
    auditor: {
      default: [],
      type: Array
    }
  },
  computed: { },
  data () {
    return {
      title_info: '样本信息'
    }
  },
  methods: {
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>

.online_wrap_info{
        min-height: 190px;
        margin-bottom: 24px;
        border-radius:10px;
        color:#595959;
        font-size: 13px;
        padding-bottom: 20px;
        &_line{
            /deep/.el-form-item:first-child{
                width: 250px;
            }
            /deep/.el-form-item:nth-child(2){
                width: 250px;
            }
            /deep/.el-form-item:nth-child(3){
                width: 250px;
            }
        }
        .demo-form-inline{
            padding-left: 30px;
            /deep/.el-form-item__content{
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width:140px;
            }
        }
    }
.demo-form-inline{
  height: 30px;
}
</style>
